import classNames from 'classnames';
import {
  FlexContainer,
  InfoMessageBlock,
  LoadingPlaceholder,
} from 'components';
import { observer } from 'mobx-react-lite';
import { useRecentProperties } from 'state';
import { PropertiesList } from '../../../../../../bricks';
import { useSearchMainState } from '../../../../state';
import styles from './SearchResultsList.module.scss';

/**
 * SearchResultsList
 *
 * @return {JSX.Element}
 */
const SearchResultsList = ({ className }) => {
  const recentProperties = useRecentProperties();

  const {
    searchResultsState: { state, isLoading },
  } = useSearchMainState();

  const handlePropertyClick = (i) => recentProperties.add(i.id);

  return (
    <FlexContainer
      className={classNames(
        styles.SearchResultsList,
        className,
        `${SearchResultsList.displayName}`
      )}
      column
    >
      {isLoading ? (
        <LoadingPlaceholder spinner padding />
      ) : state.length ? (
        <PropertiesList data={state} onBeforeClick={handlePropertyClick} />
      ) : (
        <InfoMessageBlock
          title="No property results"
          description="Sorry there are no properties here, please either refine your search or come back later"
        />
      )}
    </FlexContainer>
  );
};

SearchResultsList.displayName = 'SearchResultsList';

export default observer(SearchResultsList);
